import React, { useEffect, useState } from "react";
import BasicTable from "../../../components/InfoDisplay/InfoDisplay";
import useSave from "../../../Hooks/useSave";
import { useParams, useLocation } from "react-router-dom";

function Finishing() {
  const { fetchGraphql, DialogSave } = useSave();
  const { id } = useParams();

  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetchGraphql({
      query: `query ProductFinishings($productId: ID) {
        productFinishings(productId: $productId) {
          finishingCode
          finishingName
          finishingId
        }
      }`,
      variables: { productId: id },
    }).then((result) => {
      setRows(result.data.productFinishings);
    });
  }, []);

  const columns = [
    {
      id: "finishingCode",
      name: "Finishing Code",
      edit: true,
    },
    {
      id: "finishingName",
      name: "Finishing Name",
      edit: true,
    },
  ];

  const options = {
    handleEdit: (e, row, columnId, index) => {
      setRows((rows) => {
        const copyState = [...rows];

        copyState[index][columnId] = e.target.value;

        return copyState;
      });
    },
    addRecord: () =>
      setRows((rows) => [
        ...rows,
        {
          finishingCode: "",
          finishingName: "",
        },
      ]),
    handleSave: (index) => {
      rows[index].finishingId
        ? fetchGraphql({
            query: `mutation UpdateFinishing($finishingId: ID, $finishing: FinishingInput) {
              updateFinishing(finishingId: $finishingId, finishing: $finishing)
            }`,
            variables: {
              finishingId: rows[index].finishingId,
              finishing: rows[index],
            },
          })
        : fetchGraphql({
            query: `mutation CreateFinishings($productId: ID, $finishing: [FinishingInput]) {
              createFinishings(productId: $productId, finishing: $finishing)
            }
            `,
            variables: { productId: id, finishing: [rows[index]] },
          }).then((result) => {
            setRows((rows) => {
              const copyState = [...rows];

              copyState[index].finishingId = result.data.createFinishings;

              return copyState;
            });
          });
    },
    handleDontSave: (originalRow, index) => {
      setRows((rows) => {
        const copyState = [...rows];

        copyState[index] = originalRow;

        return copyState;
      });
    },
    handleDelete: (row, index) => {
      fetchGraphql({
        query: `mutation DeleteFinishing($finishingId: ID) {
          deleteFinishing(finishingId: $finishingId)
        }`,
        variables: { finishingId: rows[index].finishingId },
      }).then((result) => {
        result.data.deleteFinishing
          ? setRows((rows) => {
              const copyState = [...rows];

              copyState.splice(index, 1);

              return copyState;
            })
          : alert("Error deleting finishing");
      });
    },
  };

  return (
    <BasicTable
      columns={columns}
      key="2"
      rows={rows}
      header="Finishing"
      options={options}
    />
  );
}

export default Finishing;
